import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import { sync } from 'vuex-router-sync';
import {
    Steps,
    Message,
    Step,
    Dropdown,
    DropdownMenu,
    Menu,
    MenuItem,
    MenuItemGroup,
    DropdownItem,
    Submenu,
    Tag,
    Button,
    Select,
    Tabs,
    TabPane,
    Breadcrumb,
    BreadcrumbItem,
    Form,
    FormItem,
    Input,
    Row,
    Col,
    Alert,
    Icon,
    Popover,
    Container,
    Main,
    Header,
    RadioGroup,
    Radio,
    RadioButton,
    Table,
    TableColumn,
    Pagination,
    Dialog,
    Card,
    Option,
    Checkbox,
    Drawer,
    MessageBox,
    Carousel,
    CarouselItem,
    Avatar,
    Loading,
    Notification,
    Tooltip,
    Cascader,
    CascaderPanel,
    Upload,
    InputNumber,
    CheckboxGroup,
    DatePicker,
    TimePicker,
    Switch,
    Progress,
    Link,
    Calendar,
    TimeSelect,
    Badge,
    Divider,
    ButtonGroup,
    Image,
} from '@ks/kwai-ui';
import Permit from '../component/permit/index.vue';
// import AutoGenerateForm from 'auto-generate-form';
// import sentry from '@utils/sentry';
// import '@utils/ktrace'; // ktrace 在 weblog 之前引入
import weblog from '@utils/weblog';
import ksWeblog, { logger } from '@utils/ksWeblog';
// import { addRoutes } from '@utils/permission/router';
import { addRoutes } from '@utils/permission/newRouter';
import { createDirective } from '@directives/index';
import '@filters';
import clipboard from 'clipboard';
import '@ks/kwai-ui-theme-new-era/lib/index.css';
import echarts from 'echarts';

const NOTFOUND = -1;

export default class App {
    config: any;
    constructor(config) {
        this.config = config;
    }

    bootstrap() {
        Vue.use(VueLazyload, {
            error: require('@asset/images/fff.png'),
            observer: true,
            observerOptions: {
                rootMargin: '0px',
                threshold: 0.1,
            },
        });

        Vue.use(Loading.directive);
        Vue.use(createDirective());
        // Vue.use(AutoGenerateForm);
        // Vue.component('AutoGenerateForm', AutoForm);
        [
            Steps,
            Message,
            Step,
            Dropdown,
            DropdownMenu,
            Menu,
            MenuItem,
            MenuItemGroup,
            DropdownItem,
            Submenu,
            Tag,
            Button,
            Select,
            Tabs,
            TabPane,
            Breadcrumb,
            BreadcrumbItem,
            Form,
            FormItem,
            Input,
            Row,
            Col,
            Alert,
            Icon,
            Popover,
            Container,
            Main,
            Header,
            RadioGroup,
            Radio,
            RadioButton,
            Table,
            TableColumn,
            Pagination,
            Dialog,
            Card,
            Option,
            Checkbox,
            Drawer,
            MessageBox,
            Notification,
            Carousel,
            CarouselItem,
            Avatar,
            Radio,
            Tooltip,
            Cascader,
            CascaderPanel,
            Upload,
            InputNumber,
            CheckboxGroup,
            DatePicker,
            TimePicker,
            Switch,
            Progress,
            Link,
            Calendar,
            TimeSelect,
            Badge,
            Divider,
            ButtonGroup,
            RadioGroup,
            RadioButton,
            Image,
        ].forEach((COMP: any) => {
            Vue.component(COMP.name, COMP);
        });
        Vue.component('permit', Permit);

        Vue.prototype.$msgbox = MessageBox;
        Vue.prototype.$alert = MessageBox.alert;
        Vue.prototype.$confirm = MessageBox.confirm;
        Vue.prototype.$prompt = MessageBox.prompt;
        Vue.prototype.$message = Message;
        Vue.prototype.$notify = Notification;
        Vue.prototype.$echarts = echarts;

        Vue.prototype.clipboard = clipboard;

        /**
         * 绑定js error
         */
        const _oldOnError = Vue.config.errorHandler;

        // 建议打印看下原来的_oldOnError有没有事件，以及更新后事件还有没有执行
        Vue.config.errorHandler = function (err, vm, info) {
            // radar上报
            if (process.env.KS_ENV === 'prod' && logger) {
                // eslint-disable-next-line
                logger?.plugins?.radar?.captureException?.(err);
            }

            // 执行原来的errorHandler
            if (typeof _oldOnError === 'function') {
                // eslint-disable-next-line
                _oldOnError.call(this, err, vm, info);
            }
            // 输出控制台
            if (process.env.KS_ENV !== 'prod') {
                // eslint-disable-next-line
                console.error(err);
            }
        };

        if (EASY_ENV_IS_NODE) {
            return this.server();
        }
        return this.client();
    }

    create(initState) {
        const { entry, createRouter, createStore } = this.config;
        const router = createRouter();
        const store = createStore(initState);
        sync(store, router);
        return {
            router,
            store,
            render: h => {
                // not use ...entry, why ?
                return h(entry);
            },
        };
    }

    fetch(vm): Promise<any> {
        const { store, router, $http } = vm;
        const matchedComponents = router.getMatchedComponents();
        if (!matchedComponents) {
            return Promise.reject('No Match Component');
        }
        return Promise.all(
            matchedComponents.map((component: any) => {
                if (!component) {
                    return null;
                }
                const options = component.options;
                if (options && options.methods && options.methods.asyncData) {
                    return options.methods.asyncData.call(component, {
                        $http,
                        store,
                        router,
                        route: router.currentRoute,
                    });
                }
                return null;
            })
        );
    }

    client() {
        const axiosCreate = require('./http/axios-client').default;
        const axiosInstance = axiosCreate();
        Vue.prototype.$http = axiosInstance;
        Vue.prototype.$weblog = weblog;
        Vue.prototype.$ksWeblog = ksWeblog;

        // sentry.init();

        const vm = this.create(window.__INITIAL_STATE__);
        vm.$http = axiosInstance;
        vm.router.afterEach(() => {
            this.fetch(vm);
        });
        // addRoutes(vm.store, vm.router);
        const app = new Vue(vm);
        const root = document.getElementById('app');
        const hydrate = root.childNodes.length > 0;
        app.$mount(root, hydrate);
        return app;
    }

    server() {
        Vue.prototype.$weblog = weblog;
        Vue.prototype.$ksWeblog = ksWeblog;
        return context => {
            const axiosCreate = require('./http/axios-server').default;
            const axiosInstance = axiosCreate();
            const ctx = context.state.ctx;
            const { url, origin, locale, csrf, userInfo, source, ssr, loginConfig, bizUrl } = context.state;
            const vm = this.create({
                csrf,
                locale,
                origin,
                url,
                bizUrl,
                ssr,
                source,
                userInfo,
                loginConfig,
            });
            const { store, router } = vm;
            // addRoutes(vm.store, vm.router, context);
            router.push(context.state.url);
            Vue.prototype.$ctx = context;
            vm.$http = axiosInstance;

            axiosInstance.interceptors.request.use(
                function (config) {
                    config.metadata = { startTime: new Date() };
                    config.headers = {
                        cookie: ctx.header.cookie || '',
                    };
                    for (const key in context.state.proxy) {
                        if (config.url.indexOf(key) > NOTFOUND) {
                            config.url = context.state.proxy[key].target + config.url;
                            break;
                        }
                    }
                    return config;
                },
                function (error) {
                    ctx.getLogger('monitorLogger').error(
                        JSON.stringify({
                            level: 'error',
                            type: 'request',
                            url: error.config?.url,
                            method: error.config?.method?.toUpperCase(),
                            code: error.code,
                            status: error.status,
                        })
                    );
                    ctx.logger.error('server axios request error', error);
                    return Promise.reject(error);
                }
            );

            axiosInstance.interceptors.response.use(
                function (response) {
                    response.config.metadata.endTime = new Date();
                    const { status, message, result, error_msg, code, msg, errMsg } = response.data;
                    // 此处的 status 是业务的 status，状态码不为 200 时需要打点记录
                    if (status !== 200 && status !== 1 && result !== 1 && code !== 200) {
                        ctx.getLogger('monitorLogger').error(
                            JSON.stringify({
                                level: 'error',
                                type: 'response',
                                url: response.config.url,
                                method: response.config.method.toUpperCase(),
                                msg: message || error_msg || msg || errMsg,
                                status: typeof status === 'undefined' ? result : status,
                            })
                        );
                    } else {
                        ctx.getLogger('monitorLogger').info(
                            JSON.stringify({
                                level: 'info',
                                type: 'axios',
                                url: response.config.url,
                                method: response.config.method.toUpperCase(),
                                duration: response.config.metadata.endTime - response.config.metadata.startTime,
                            })
                        );
                    }
                    return response;
                },
                function (error) {
                    ctx.getLogger('monitorLogger').error(
                        JSON.stringify({
                            level: 'error',
                            type: 'response',
                            url: error.config.url,
                            method: error.config.method.toUpperCase(),
                            code: error.code,
                            status: error.status,
                        })
                    );
                    ctx.logger.error('server axios response error', error);
                    return Promise.reject(error);
                }
            );

            return new Promise((resolve, reject) => {
                router.onReady(() => {
                    this.fetch(vm)
                        .then(() => {
                            context.state = {
                                ...store.state,
                                ...context.state,
                            };
                            return resolve(new Vue(vm));
                        })
                        .catch(error => {
                            ctx.getLogger('monitorLogger').error(
                                JSON.stringify({
                                    level: 'error',
                                    type: 'asyncData',
                                    url: ctx.req.url,
                                    method: ctx.method,
                                })
                            );
                            ctx.logger.error('asyncData error', error);
                            reject(error);
                        });
                });
            });
        };
    }
}
